import React, {Fragment} from 'react';
import './DynaModal.scss';
import ReactDOM from "react-dom";

const Backdrop = (props) => {
    return <div className="backdrop" onClick={props.onClose}/>;
};

const ModalOverlay = (props) => {
    return (
        <div className={props.className}>
            <div>{props.children}</div>
        </div>
    );
};

const portalElement = document.getElementById('overlay-root');

const DynaModal = (props) => {

    return (
        <Fragment>
            {ReactDOM.createPortal(<Backdrop onClose={props.onClose}/>, portalElement)}
            {ReactDOM.createPortal(
                <ModalOverlay className={props.className}>{props.children}</ModalOverlay>,
                portalElement
            )}
        </Fragment>
    );
};
export default DynaModal;